import * as React from 'react';
import { RadioButtonOn, RadioButtonOff } from '@next-common/material-ui-icons';
import { styled } from '@mui/material';
const RadioButtonIconRoot = styled('span')({
    position: 'relative',
    display: 'flex',
});
const RadioButtonIconBackground = styled(RadioButtonOff)({
    transform: 'scale(1)',
});
//@ts-expect-error ownerState
const RadioButtonIconDot = styled(RadioButtonOn)(({ theme, ownerState }) => (Object.assign({ left: 0, position: 'absolute', transform: 'scale(0)', transition: theme.transitions.create('transform', {
        easing: theme.transitions.easing.easeIn,
        duration: theme.transitions.duration.shortest,
    }) }, (ownerState.checked && {
    transform: 'scale(1)',
    transition: theme.transitions.create('transform', {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.shortest,
    }),
}))));
export const RadioButtonIcon = (props) => {
    const { checked = false } = props;
    const ownerState = Object.assign(Object.assign({}, props), { checked });
    return (
    // @ts-expect-error ownerState
    React.createElement(RadioButtonIconRoot, { ownerState: ownerState },
        React.createElement(RadioButtonIconBackground, { style: { fontSize: '16px' }, ownerState: ownerState }),
        React.createElement(RadioButtonIconDot, { style: { fontSize: '16px' }, ownerState: ownerState })));
};
